import ModalFilter from './ModalFilter';

export default ModalFilter;
